<template>
  <div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <!-- 主表 -->
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
        :rules="rulesForm"
      >
        <el-form-item
          prop="tableName"
          class="queryItems"
          label="主表:"
          label-width="120px;"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.tableName"
            placeholder="请输入"
            @change="changeMainTable"
          >
            <el-option
              v-for="(item, index) in tableLists"
              :key="index"
              :label="item.TABLE_NAME + ' (' + item.TABLE_COMMENT + ')'"
              :value="item.TABLE_NAME"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="tableNameAlias" class="queryItems" label="表别名:">
          <el-input
            clearable
            v-model="queryData.tableNameAlias"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="reportName" class="queryItems" label="报表名称:">
          <el-input
            clearable
            v-model="queryData.reportName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item prop="number" class="queryItems" label="编号:">
          <el-input
            clearable
            v-model="queryData.number"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 子表 -->
      <el-form
        :model="relationReqsA"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <div
          class="queryFormRows"
          v-for="(itemC, index) in relationReqs"
          :key="index"
        >
          <el-form-item class="queryItems" label="子表:">
            <el-select
              filterable
              clearable
              v-model="itemC.tableName"
              placeholder="请输入"
              @change="changeChildTable($event, index)"
            >
              <el-option
                v-for="(item, index) in tableLists"
                :key="index"
                :label="item.TABLE_NAME + ' (' + item.TABLE_COMMENT + ')'"
                :value="item.TABLE_NAME"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="tableNameAlias"
            class="queryItems"
            label="表别名:"
          >
            <el-input
              clearable
              v-model="itemC.tableNameAlias"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <div
            style="
              font-size: 12px;
              margin-left: 30px;
              width: 60px;
              line-height: 30px;
            "
          >
            关联条件
          </div>
          <el-form-item style="" class="queryItems shortInput">
            <el-input
              clearable
              v-model="itemC.prefixSymbol"
              placeholder="前缀符号"
            ></el-input>
          </el-form-item>

          <el-form-item class="queryItems">
            <el-select
              filterable
              clearable
              v-model="itemC.conditionLeftField"
              placeholder="条件1字段"
            >
              <el-option
                v-for="(item, index) in childTableFileds"
                :key="index"
                :label="item.COLUMN_NAME"
                :value="item.COLUMN_NAME"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="margin-right: 10px">=</div>
          <!-- 条件所属表: -->
          <el-form-item class="queryItems" label="">
            <el-select
              filterable
              clearable
              v-model="itemC.conditonValFieldTable"
              placeholder="条件2所属表"
              @change="changeChildTable3($event, index)"
            >
              <el-option
                v-for="(item, index) in hasChangeChildTable"
                :key="index"
                :label="'(' + item.tableNameAlias + ') ' + item.TABLE_NAME"
                :value="item.TABLE_NAME"
                :disabled="item.TABLE_NAME == itemC.tableName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="">
            <el-select
              filterable
              clearable
              allow-create
              v-model="itemC.conditonVal"
              placeholder="条件2字段:"
            >
              <el-option
                v-for="(item, index) in ChildFiledsLists"
                :key="index"
                :label="item.COLUMN_NAME"
                :value="item.COLUMN_NAME"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems shortInput" label="">
            <el-input
              clearable
              v-model="itemC.suffixSymbol"
              placeholder="条件后符号"
            ></el-input>
          </el-form-item>
          <el-button
            v-if="index == relationReqs.length - 1"
            class="glo_btnItems"
            style="padding: 0px 10px; height: 34px; color: #ef7c0a"
            @click="addGLTJ(idx)"
            >新增
          </el-button>
          <el-button
            v-if="relationReqs.length > 1"
            class="glo_btnItems"
            style="padding: 0px 10px; height: 34px"
            @click="delGLTJ(idx)"
            >移除
          </el-button>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <div class="tableLeft">
        <el-table
          :height="tableHeigth"
          header-align="center"
          ref="mytableleft"
          @row-click="rowclickLeft"
          :data="tableDataLeft"
          border
          stripe
          :highlight-current-row="true"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          >
          </el-table-column> -->
          <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column>
          <template v-for="(item, index) in myTableHeardLeft">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            >
            </el-table-column>
          </template>
        </el-table>
      </div>

      <div class="glo_btnList glo_btnList_min">
        <div class="glo_btnList_left">
          <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="confirmFileds"
            >确定选择
          </el-button>

          <el-button class="glo_btnItems" @click="cancelFileds"
            >取消选择</el-button
          >
        </div>
      </div>

      <div class="tableRightClass">
        <el-table
          :height="tableHeigth"
          :data="fieldReqs"
          border
          style="width: 100%"
        >
          <el-table-column
            show-overflow-tooltip
            prop="goodsName"
            label="表别名"
          >
            <template slot-scope="scope">
              <el-input
                disabled
                type="text"
                v-model="fieldReqs[scope.$index].fieldTableAlias"
                placeholder="请输入"
                filterable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="itemCategoryName"
            label="字段名"
          >
            <template slot-scope="scope">
              <el-select
                v-model="fieldReqs[scope.$index].fieldName"
                filterable
                clearable
                allow-create
                default-first-option
                placeholder="请选择"
              >
                <el-option
                  v-for="item2 in insuranceCoverageArrs"
                  :key="item2.key"
                  :label="item2.key"
                  :value="item2.key"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="goodsName"
            label="字段别名"
          >
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="fieldReqs[scope.$index].fieldAlias"
                placeholder="请输入"
                filterable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="goodsName"
            label="字段展示值"
          >
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="fieldReqs[scope.$index].fieldNameShow"
                placeholder="请输入"
                filterable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="goodsName" label="函数">
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="fieldReqs[scope.$index].countType"
                placeholder="请输入"
                filterable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="goodsName"
            label="自定义公式"
          >
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="fieldReqs[scope.$index].customFieldVal"
                placeholder="请输入"
                filterable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="goodsName" label="排序">
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="fieldReqs[scope.$index].sort"
                placeholder="请输入"
                filterable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="50px">
            <template slot-scope="scope">
              <div class="tabRightBtns">
                <el-button class="rbtns" @click.stop="delFilesBtn(scope.$index)"
                  >移除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div ref="queryForm">
      <el-form
        :model="conditionReqA"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 查询条件 -->
        <el-button
          class="glo_btnItems"
          style="
            padding: 0px 10px;
            height: 34px;
            color: #ef7c0a;
            margin-bottom: 10px;
          "
          @click="addCZTJ(idx)"
          >新增查询条件
        </el-button>
        <div
          class="queryFormRows"
          v-for="(itemA, index) in conditionReqs"
          :key="index"
        >
          <div style="font-size: 12px; width: 60px; line-height: 30px">
            查询条件{{ index + 1 }}
          </div>
          <el-form-item class="queryItems shortInput" label="">
            <el-input
              clearable
              v-model="itemA.prefixSymbol"
              placeholder="前缀:"
            ></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="">
            <el-select
              filterable
              clearable
              v-model="itemA.conditionLeftFieldTable"
              placeholder="条件1所属表"
              @change="changeChildTable4($event, index)"
            >
              <el-option
                v-for="(item, index) in hasChangeChildTable"
                :key="index"
                :label="'(' + item.tableNameAlias + ') ' + item.TABLE_NAME"
                :value="item.TABLE_NAME"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="queryItems" label="">
            <el-select
              filterable
              clearable
              v-model="itemA.conditionLeftField"
              placeholder="条件1字段:"
            >
              <el-option
                v-for="(item, index) in ChildFiledsLists4"
                :key="index"
                :label="item.COLUMN_NAME"
                :value="item.COLUMN_NAME"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="margin-right: 10px">=</div>
          <el-form-item class="queryItems" label="">
            <el-input
              clearable
              v-model="itemA.conditonVal"
              placeholder="条件2值:"
            ></el-input>
          </el-form-item>
          <el-form-item class="queryItems shortInput" label="">
            <el-input
              clearable
              v-model="itemA.suffixSymbol"
              placeholder="条件后符号:"
            ></el-input>
          </el-form-item>

          <el-button
            class="glo_btnItems"
            style="padding: 0px 10px; height: 34px"
            @click="delCZTJ(idx)"
            >移除
          </el-button>
        </div>
      </el-form>

      <!-- 报表维度 -->
      <div class="btmBtns">
        <el-form
          :model="groupReqA"
          :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
          label-position="left"
        >
          <el-button
            class="glo_btnItems"
            style="
              padding: 0px 10px;
              height: 34px;
              color: #ef7c0a;
              margin-bottom: 10px;
            "
            @click="addFZ(idx)"
            >新增维度分组
          </el-button>
          <div
            class="queryFormRows"
            v-for="(itemB, index) in groupReqs"
            :key="index"
          >
            <div style="font-size: 12px; width: 60px; line-height: 30px">
              报表维度 {{ index + 1 }}
            </div>
            <el-form-item class="queryItems" label="">
              <el-select
                filterable
                clearable
                v-model="itemB.fieldTable"
                placeholder="分组所属表"
                @change="changeChildTable5($event, index)"
              >
                <el-option
                  v-for="(item, index) in hasChangeChildTable"
                  :key="index"
                  :label="'(' + item.tableNameAlias + ') ' + item.TABLE_NAME"
                  :value="item.TABLE_NAME"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems">
              <el-select
                filterable
                clearable
                v-model="itemB.groupFieldName"
                placeholder="分组字段"
              >
                <el-option
                  v-for="(item, index) in ChildFiledsLists5"
                  :key="index"
                  :label="item.COLUMN_NAME"
                  :value="item.COLUMN_NAME"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button
              class="glo_btnItems"
              style="padding: 0px 10px; height: 34px"
              @click="delFZ(idx)"
              >移除
            </el-button>
          </div>
        </el-form>

        <el-button
          style="margin-right: 100px"
          class="glo_btnItems glo_bgcMainColor"
          @click="confirmAddReport"
          >保存
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import multitime from "@/components/multiTime.vue";
import jsPDF from "jspdf";
export default {
  components: {
    multitime,
  },
  data() {
    return {
      queryData: {
        tableName: "",
        tableNameAlias: "",
        number: "",
        reportName: "",
      },

      isHaseMore: true,

      tableHeigth: "70vh",

      selectTableDataLeft: [],
      selectTableDataRight: [],
      tableDataLeft: [], //主表字段
      childTableFileds: [], //子表条件1字段
      ChildFiledsLists: [], //子表条件2字段
      ChildFiledsLists4: [], //查询条件  条件1字段
      ChildFiledsLists5: [], //维度  条件1字段
      hasChangeChildTable: [], //已选过的表

      tableDataRigth: [],
      myTableHeardLeft: [
        {
          name: "表字段",
          field: "COLUMN_NAME",
          width: "100",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "字段内容",
          field: "COLUMN_COMMENT",
          width: "100",
          sort: 2,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      // =
      fieldReqs: [],
      insuranceCoverageArrs: [], //险种

      tableLists: [], //数据表

      // 报表查询条件(底部)
      conditionReqA: {},
      conditionReqs: [],
      // 报表维度
      groupReqA: {},
      groupReqs: [],
      relationReqsA: {},
      relationReqs: [
        {
          conditionLeftField: "", //关联表的条件字段
          conditions: [], //子级查询条件
          conditonVal: "", //条件值(可能为字段,可能为值(值用单引号括起),可能为变量(变量前用#号))
          conditonValFieldTable: "", //条件值所属表(可能没有)
          conditonValFieldTableAlias: "", //条件值所属表别名(可能没有)
          sort: "", //排序
          prefixSymbol: "", //条件前的符号
          suffixSymbol: "", //条件后的符号
          tableName: "", //关联表名
          tableNameAlias: "", //关联表名别名
        },
      ],
      rulesForm: {
        tableName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        tableNameAlias: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      rulesForm2: {
        tableName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        tableNameAlias: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      childIdx: 0,
    };
  },
  watch: {},
  created() {
    this.getTables();
  },
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    // 新增分组
    addFZ(idx) {
      let objs = {
        fieldTable: "",
        fieldTableAlias: "",
        groupFieldName: "",
      };
      this.groupReqs.push(objs);
    },
    // 移除分组
    delFZ(idx) {
      this.$confirm("是否删除该查询条件", "提示")
        .then(() => {
          let arrs = JSON.parse(JSON.stringify(this.groupReqs));
          arrs.splice(idx, 1);
          this.groupReqs = arrs;
        })
        .catch((err) => {});
    },
    // 新增查询条件
    addCZTJ(idx) {
      let objs = {
        conditionLeftField: "", //条件字段
        conditionLeftFieldTable: "", //条件字段所属表(可能没有)
        conditionLeftFieldTableAlias: "", //条件字段所属表别名(可能没有)
        conditonVal: "", //	条件值(可能为字段,可能为值(值用单引号括起),可能为变量(变量前用#号))
        prefixSymbol: "", //条件前的符号
        suffixSymbol: "", //条件后的符号
        sort: "",
      };
      this.conditionReqs.push(objs);
    },
    // 移除查询条件
    delCZTJ(idx) {
      this.$confirm("是否删除该查询条件", "提示")
        .then(() => {
          let arrs = JSON.parse(JSON.stringify(this.conditionReqs));
          arrs.splice(idx, 1);
          this.conditionReqs = arrs;
        })
        .catch((err) => {});
    },
    // 移除关联条件
    addGLTJ(idx) {
      let objs = {
        conditionLeftField: "", //关联表的条件字段
        conditions: [], //子级查询条件
        conditonVal: "", //条件值(可能为字段,可能为值(值用单引号括起),可能为变量(变量前用#号))
        conditonValFieldTable: "", //条件值所属表(可能没有)
        conditonValFieldTableAlias: "", //条件值所属表别名(可能没有)
        sort: "", //排序
        prefixSymbol: "", //条件前的符号
        suffixSymbol: "", //条件后的符号
        tableName: "", //关联表名
        tableNameAlias: "", //关联表名别名
      };
      this.relationReqs.push(objs);
    },
    // 移除关联条件
    delGLTJ(idx) {
      this.$confirm("是否删除该关联条件", "提示")
        .then(() => {
          let arrs = JSON.parse(JSON.stringify(this.relationReqs));
          arrs.splice(idx, 1);
          this.relationReqs = arrs;
        })
        .catch((err) => {});
    },

    // 保存
    confirmAddReport() {
      if (!this.queryData.tableName) {
        this.$message.error("请选择主表");
        return false;
      }

      let param = {
        conditionReqs: this.conditionReqs || [],
        fieldReqs: this.fieldReqs || [],
        groupReqs: this.groupReqs || [],
        infoReq: {
          number: this.queryData.number,
          reportName: this.queryData.reportName,
          tableName: this.queryData.tableName,
          tableNameAlias: this.queryData.tableNameAlias,
        },
        relationReqs: this.relationReqs || [],
      };
      this.$API.addReport(param).then((res) => {
        this.$message.success(res.data.message || "");
      });
    },
    // 删除已选字段
    delFilesBtn(idx) {
      this.$confirm("是否删除所选字段?", "提示:")
        .then((res) => {
          let datas = JSON.parse(JSON.stringify(this.fieldReqs));
          datas.splice(idx, 1);
          this.fieldReqs = datas;
        })
        .catch((err) => {});
    },

    arrDistinctByProp(arr, prop) {
      let obj = [];
      return arr.reduce(function (preValue, item) {
        obj[item[prop]] ? "" : (obj[item[prop]] = true && preValue.push(item));
        return preValue;
      }, []);
    },
    // 根据name去重

    getTables() {
      this.$API.getTableList().then((res) => {
        this.tableLists = res.data.result || [];
      });
    },
    // 确定字段
    confirmFileds() {
      if (this.selectTableDataLeft.length < 1) {
        this.$message.error("请选择字段");
        return false;
      }
      let tableNameAlias =
        this.leftTableType == "main"
          ? this.queryData.tableNameAlias
          : this.relationReqs[this.childIdx].tableNameAlias;
      if (!tableNameAlias) {
        this.$message.error("请填写表的别名");
        return false;
      }

      let datas = this.selectTableDataLeft;
      console.log(datas);
      let arrs = [];
      datas.forEach((item, index) => {
        let objs = {
          countType: "",
          customFieldVal: "",
          fieldAlias: "",
          fieldName: item.COLUMN_NAME,
          fieldNameShow: item.COLUMN_COMMENT,
          fieldTable:
            this.leftTableType == "main"
              ? this.queryData.tableName
              : this.relationReqs[this.childIdx].tableName,
          fieldTableAlias: tableNameAlias,
          sort: index + 1,
        };
        arrs.push(objs);
      });

      this.fieldReqs = [...this.fieldReqs, ...arrs];

      //保存已选过的表名
      let arrList = JSON.parse(JSON.stringify(this.hasChangeChildTable || []));
      let tname =
        this.leftTableType == "main"
          ? this.queryData.tableName
          : this.relationReqs[this.childIdx].tableName;

      this.tableLists.forEach((item) => {
        if (item.TABLE_NAME == tname) {
          item.tableNameAlias = tableNameAlias;
          arrList.push(item);
        }
      });

      // 去重
      let newArrs = this.arrDistinctByProp(arrList, "TABLE_NAME");
      this.hasChangeChildTable = newArrs;
      console.log("this.hasChangeChildTable", this.hasChangeChildTable);
    },
    cancelFileds() {
      this.$refs.mytableleft.clearSelection();
      this.selectTableDataLeft = [];
    },

    // 选择主表
    changeMainTable(e) {
      console.log(e);
      if (e) {
        this.getColumnList(e, "1");
        this.leftTableType = "main";
      }
    },
    // 选择子表
    changeChildTable(e, idx) {
      this.relationReqs[idx].conditionLeftField = "";
      this.childIdx = 0;
      this.tableDataLeft = [];
      if (e) {
        this.getColumnList(e, 2);
        this.leftTableType = "child";
        this.childIdx = idx;
      }
    },
    // 选择条件
    changeChildTable3(e, idx) {
      this.relationReqs[idx].conditonVal = "";
      if (e) {
        this.hasChangeChildTable.forEach((item) => {
          if (item.TABLE_NAME == e) {
            this.relationReqs[idx].conditonValFieldTableAlias =
              item.tableNameAlias;
          }
        });
        this.getColumnList(e, 3);
      }
    },
    //
    changeChildTable4(e, idx) {
      this.conditionReqs[idx].fieldTableAlias = "";
      this.conditionReqs[idx].groupFieldName = "";
      if (e) {
        this.hasChangeChildTable.forEach((item) => {
          if (item.TABLE_NAME == e) {
            this.conditionReqs[idx].conditionLeftFieldTableAlias =
              item.tableNameAlias;
          }
        });
        this.getColumnList(e, 4);
      }
    },
    //
    changeChildTable5(e, idx) {
      this.groupReqs[idx].fieldTableAlias = "";
      this.groupReqs[idx].groupFieldName = "";
      if (e) {
        this.hasChangeChildTable.forEach((item) => {
          if (item.TABLE_NAME == e) {
            this.groupReqs[idx].fieldTableAlias = item.tableNameAlias;
          }
        });

        this.getColumnList(e, 5);
      }
    },
    // 获取表字段
    getColumnList(e, typeNum) {
      this.$API.getColumnList({ tableName: e }).then((res) => {
        let data = res.data.result || [];
        if (typeNum == 1) {
          // typeNum==1    主表字段
          this.tableDataLeft = data;
        } else if (typeNum == 2) {
          // typeNum==2    子表字段
          this.childTableFileds = data;
          this.tableDataLeft = data;
        } else if (typeNum == 3) {
          // typeNum==2
          this.ChildFiledsLists = data;
        } else if (typeNum == 4) {
          // typeNum==4  查询条件
          this.ChildFiledsLists4 = data;
        } else if (typeNum == 5) {
          // typeNum==4    报表维度
          this.ChildFiledsLists5 = data;
        }
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableDataLeft = e;
    },
    handleSelectionChange2(e) {
      // 表格选择事件
      this.selectTableDataRight = e;
    },
    // 点击选中当前行
    rowclickLeft(row, event, column) {
      this.$refs.mytableleft.toggleRowSelection(row);
    },
  },
};
</script>
<style scoped lang='less'>
.glo_Table {
  display: flex;
  // flex-wrap: wrap;
  width: 100%;

  .tableLeft {
    width: 300px;
    // margin-right: 20px;
  }
  .tableRightClass {
    flex: 1;
  }
}

.goodsTable {
  /deep/ .el-input__icon {
    line-height: 30px;
  }
}

.iconList {
  text-align: center;

  .iconSize {
    font-size: 26px;
  }
}

.queryFormRows {
  display: flex;
  width: 100%;
}
.queryItems {
  // width: 300px;
  /deep/ .el-input__inner {
    width: 100%;
  }
  /deep/ .el-form-item__content,
  .el-select {
    width: 100% !important;
  }
}

/deep/ .el-form-item__label {
  min-width: 80px;
}

.shortInput {
  width: 80px;

  // /deep/ .el-input__inner {
  //   width: 70px;
  // }
}

.glo_btnList_min {
  width: 70px;
  justify-content: center;
  align-items: center;
  margin: 0 10px;

  .glo_btnList_left {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .glo_btnItems {
      height: 30px;
      margin: 0 0 20px 0;
    }
  }
}

.btmBtns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>